import { Editor } from '@tiptap/core';
import { nanoid } from 'nanoid';
import { Logger } from '@/other/Logger';

const log = new Logger('TipTap:editor');

export class TipTapEditorService {
  protected editorsMap: { [key: string]: Editor } = {};

  registerEditor = (key: string, editor: Editor) => {
    log.info(`Editor registered #${key}`);
    this.editorsMap[key] = editor;
    return editor;
  };

  generateKey = () => nanoid(10);

  destroyEditor = (editorKey: string) => {
    const editor = this.editorsMap[editorKey];
    if (!editor) return;
    try {
      editor.destroy();
    } catch (e) {
      log.info(`editor destroy warning #${editorKey}: ${(e as Error).message}`);
    }
    delete this.editorsMap[editorKey];
    log.info(`editor destroyed #${editorKey}`);
  };

  get = (key: string) => this.editorsMap[key];
}

const tipTapEditorService = new TipTapEditorService();
export default tipTapEditorService;
